<script>
//utils
import swissRoundHelper from './mixins/roundHelper';
//components
import Table from '@/views/tournaments/management/brackets/components/TableView';
export default {
  name: 'TournamentSwissTableView',
  functional: true,
  props: {
    roundID: {
      type: [Number, String],
      default: 0,
    },
  },
  render(h, context) {
    return h(Table, {
      props: {
        roundName: swissRoundHelper.methods.roundName,
        roundID: context.props.roundID,
      },
      on: context.listeners,
    });
  },
};
</script>
